type WalletConnectLogger = {
  level: string;
  trace: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  fatal: (...args: unknown[]) => void;
  child: (bindings?: { context?: string }) => WalletConnectLogger;
  bindings: () => { context?: string };
};

function loggerMethod(method: 'info' | 'warn' | 'error', context: string) {
  return (...args: unknown[]) => {
    const prefix = context ? `[WalletConnect:${context}]` : '[WalletConnect]';
    console[method](prefix, ...args);
  };
}

export function createWalletConnectLogger(context = ''): WalletConnectLogger {
  const logger: WalletConnectLogger = {
    level: 'error',
    trace: () => undefined,
    debug: () => undefined,
    info: loggerMethod('info', context),
    warn: loggerMethod('warn', context),
    error: loggerMethod('error', context),
    fatal: loggerMethod('error', context),
    child: (bindings) => {
      const childContext = bindings?.context?.trim();
      let nextContext = context;

      if (childContext) {
        if (!context || childContext === context || childContext.startsWith(`${context}/`)) {
          nextContext = childContext;
        } else {
          nextContext = `${context}/${childContext}`;
        }
      }

      return createWalletConnectLogger(nextContext);
    },
    bindings: () => (context ? { context } : {}),
  };

  return logger;
}
